export const name = '@issuu/tracking-micro';
export const version = '13.0.1';
//# sourceMappingURL=pkginfo.js.map